import {ApplicationError} from '../model/application-error';
import {ApiRoutes} from '../../../config/api-routes';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {noop} from 'rxjs';

@Injectable()
export class ErrorLogService {

  constructor(private httpClient: HttpClient, private routes: ApiRoutes) {}

  public sendError(error: ApplicationError) {
    this.httpClient.post(this.routes.ERROR_LOG, error).subscribe(noop);
  }
}
